import React from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";
import { AppShell } from "@/components/layout/AppShell";
import { LandingPage } from "@/pages/LandingPage";
import { OnboardingPage } from "@/pages/OnboardingPage";
import { DashboardPage } from "@/pages/DashboardPage";
import { MenuPage } from "@/pages/MenuPage";
import { MenuNextPage } from "@/pages/MenuNextPage";
import { RecipeDetailPage } from "@/pages/RecipeDetailPage";
import { ShoppingListPage } from "@/pages/ShoppingListPage";
import { RecipeBookPage } from "@/pages/RecipeBookPage";
import { RecipeBookEntryPage } from "@/features/recipe-book/RecipeBookEntryPage";
import { CookingPage } from "@/pages/CookingPage";
import { BatchOverviewPage } from "@/pages/BatchOverviewPage";
import { ProfilePage } from "@/pages/ProfilePage";
import { LegalPage } from "@/pages/LegalPage";
import { FaqPage } from "@/pages/FaqPage";
import { AboutPage } from "@/pages/AboutPage";
import { NotFoundPage } from "@/pages/NotFoundPage";
import { LoginPage } from "@/features/auth/LoginPage";
import { AuthCallback } from "@/features/auth/AuthCallback";
import { RequireAuth } from "@/features/auth/RequireAuth";
import { SharedMenuPage } from "@/pages/SharedMenuPage";

const MenuRevealPage = React.lazy(() => import("@/pages/MenuRevealPage"));

export const router = createBrowserRouter([
  // Public
  { path: "/", element: <LandingPage /> },
  { path: "/login", element: <LoginPage /> },
  { path: "/auth/callback", element: <AuthCallback /> },
  { path: "/onboarding", element: <OnboardingPage /> },
  { path: "/share/:token", element: <SharedMenuPage /> },
  { path: "/legal", element: <LegalPage /> },
  { path: "/faq", element: <FaqPage /> },
  { path: "/about", element: <AboutPage /> },

  // Authed shell (bottom tab bar)
  {
    element: (
      <RequireAuth>
        <AppShell />
      </RequireAuth>
    ),
    children: [
      { path: "/dashboard", element: <DashboardPage /> },
      { path: "/menu", element: <MenuPage /> },
      { path: "/menu/next", element: <MenuNextPage /> },
      { path: "/recipe/:slug", element: <RecipeDetailPage /> },
      { path: "/shopping", element: <ShoppingListPage /> },
      { path: "/recipe-book", element: <RecipeBookPage /> },
      { path: "/recipe-book/:id", element: <RecipeBookEntryPage /> },
      { path: "/profile", element: <ProfilePage /> },
      { path: "/me", element: <Navigate to="/profile" replace /> },
    ],
  },

  // Full-screen workflows (no tab bar)
  {
    path: "/batch-overview",
    element: (
      <RequireAuth>
        <BatchOverviewPage />
      </RequireAuth>
    ),
  },
  {
    path: "/cooking",
    element: (
      <RequireAuth>
        <CookingPage />
      </RequireAuth>
    ),
  },

  // Reveal-and-curate workflow (no tab bar)
  {
    path: "/menu/reveal",
    element: (
      <RequireAuth>
        <MenuRevealPage />
      </RequireAuth>
    ),
  },

  { path: "*", element: <NotFoundPage /> },
]);
